module.exports = __webpack_public_path__ + "img/cross-platform.3c0ca37d.webp";